import { TextSnippet } from '@mui/icons-material';

// Simple preset text styles
const textStylePresets = {
  heading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '34px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  heading2: {
    fontFamily: "'Playfair Display Bold', Georgia, 'Times New Roman', serif",
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '1.2',
    letterSpacing: '-0.02em',
    color: '#101022',
    textAlign: 'left',
  },
  subheading1: {
    fontFamily: "'Proxima Nova',Helvetica,Arial,sans-serif",
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  subheading2: {
    fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '1.4',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  paragraph1: {
    fontFamily: "Lora,Lora-roboto,Lora-local,-apple-system,BlinkMacSystemFont,'Times New Roman','EB Garamond',Georgia,serif",
    fontSize: '1.125rem',
    fontWeight: 400,
    lineHeight: '1.6',
    letterSpacing: '0.01em',
    color: '#101022',
    textAlign: 'left',
  },
    // Quotation-specific presets
  quotation1: {
    fontFamily: "'Jost', sans-serif",
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
    fontStyle: 'italic',


  },
  bullet1: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',


  },
  bullet2Line1: {
    fontFamily: "'Geist', sans-serif",
    fontSize: '14px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',


  },
  bullet2Line2: {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '14px',
    fontStyle: 'medium',
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
};

// Comparison table style presets
const comparisonTableStylePresets = {
  compareTableTableTitle: {
    fontFamily: "'Geist', sans-serif",
    fontSize: '18px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'center',
  },
  compareTableProdctName: {
    fontFamily: "'Geist', sans-serif",
    fontSize: '14px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  compareTableFeatureTitle: {
    fontFamily: "'Geist', sans-serif",
    fontSize: '14px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  compareTableFeatureDescription: {
    fontFamily: "'Raanana', sans-serif",
    fontSize: '12px',
    fontStyle: 'regular',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
  compareTableTwoColumnColumnTitle: {
    fontFamily: "'Geist', sans-serif",
    fontSize: '16px',
    fontStyle: 'bold',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'center',
  },
  compareTableTwoColumnItemTitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '12px',
    fontStyle: 'medium',
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#101022',
    textAlign: 'left',
  },
};

// Button style presets
const buttonStylePresets = {
  buttonStandard: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0.09px',
    backgroundColor: '#38C558',
    color: '#ffffff',
    textAlign: 'center',
    textTransform: 'titlecase',
    width: '100%',
    borderRadius: '0px',
    padding: '12px 24px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginBottom: '0px',
    textDecoration: 'none',
  },
  buttonRounded: {
    fontFamily: "'Raleway', sans-serif",
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '0.09px',
    backgroundColor: '#ff6b35',
    color: '#ffffff',
    textAlign: 'center',
    textTransform: 'titlecase',
    borderRadius: '20px',
    padding: '12px 24px',
    width: '100%',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginBottom: '0px',
    textDecoration: 'none',
  },
  button3D: {
    backgroundColor: '#f5003c',
    color: '#fff',
    borderRadius: '16px',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: '0 8px 0 #a8002c, 0 8px 16px rgba(0,0,0,0.15)',
    padding: '18px 0',
    width: '100%',
    border: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s cubic-bezier(.25,.8,.25,1)',
    display: 'block',
    marginBottom: '0px',
    textDecoration: 'none',
  },
  buttonGradient: {
    background: 'linear-gradient(180deg, #ffe066 0%, #ffb347 100%)',
    color: '#222',
    borderRadius: '12px',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '20px 0',
    width: '100%',
    border: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s cubic-bezier(.25,.8,.25,1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '18px',
    marginBottom: '0px',
    textDecoration: 'none',
    iconLeft: 'cart',
    iconRight: 'arrow',
  },
};

// Helper function to get all preset names
export const getPresetNames = () => Object.keys(textStylePresets);

// Helper function to get a specific preset
export const getPreset = (presetName) => textStylePresets[presetName];

// Helper function to get all presets
export const getAllPresets = () => textStylePresets;

// Helper function to get all button preset names
export const getButtonPresetNames = () => Object.keys(buttonStylePresets);

// Helper function to get a specific button preset
export const getButtonPreset = (presetName) => buttonStylePresets[presetName];

// Helper function to get all button presets
export const getAllButtonPresets = () => buttonStylePresets;

// Helper function to get all comparison table preset names
export const getComparisonTablePresetNames = () => Object.keys(comparisonTableStylePresets);

// Helper function to get a specific comparison table preset
export const getComparisonTablePreset = (presetName) => comparisonTableStylePresets[presetName];

// Helper function to get all comparison table presets
export const getAllComparisonTablePresets = () => comparisonTableStylePresets;

// Helper function to get all unique font families from all presets
export const getPresetFontFamilies = () => {
  const allPresets = {
    ...textStylePresets,
    ...buttonStylePresets,
    ...comparisonTableStylePresets
  };
  
  const fontFamilies = new Set();
  
  Object.values(allPresets).forEach(preset => {
    if (preset.fontFamily) {
      fontFamilies.add(preset.fontFamily);
    }
  });
  
  const result = Array.from(fontFamilies).sort();
  console.log('🎨 Available preset font families:', result);
  return result;
};

export default textStylePresets; 